import { createFileRoute } from "@tanstack/react-router"
import LeadBoardPage from "@/components/coreLeadDocket/LeadBoardPage"

export const Route = createFileRoute("/core/lead-docket/kanban")({
  component: LeadBoardPage
})
